export const CALENDAR_LANGUAGES = {
  nl: 'nl',
  fr: 'fr',
  en: 'en',
} as const;
export type CalendarLanguages = (typeof CALENDAR_LANGUAGES)[keyof typeof CALENDAR_LANGUAGES];

export const CALENDAR_DATE_NOTATIONS = {
  nl: 'nl-NL',
  fr: 'fr-BE',
  en: 'en-GB',
} as const;
export type CalendarNotations = (typeof CALENDAR_DATE_NOTATIONS)[keyof typeof CALENDAR_DATE_NOTATIONS];
